enum ToastDuration {
  SUCCESS = 4000,
  INFO = 4000,
  WARNING = 8000,
  ERROR = 8000,
}

export default ToastDuration;
